import { Modal, ModalBody, ModalHeader } from 'Components/Partials/Modal';

import CheckInPartial from 'Pages/Dashboard/CheckIn';
import React from 'react';

const CheckIn = ({ onClose, ...props }) => (
    <Modal>
        <ModalHeader onClose={onClose}>
            Check In
        </ModalHeader>

        <ModalBody>
            <CheckInPartial
                onClose={onClose}
                {...props}
            />
        </ModalBody>
    </Modal>
);

export default CheckIn;
